module.exports = __webpack_public_path__ + "img/plus.5fd41ae2.svg";